import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { useSelector, useDispatch } from 'react-redux';
import { useWindowSize } from '@react-hook/window-size';

import { useTheme } from '../../ThemeContext';

import routes from '../../routes';

import IMAGE_LOGO from '../../assets/Images/Logo.svg';

import {
  Wrapper,
  LogoBox,
  LogoHolder,
  Logo,
  Content,
  ContentInner,
  Item,
  ItemHolder,
  ItemTitle,
  Grow,
  Toggler,
  TogglerIcon,
} from './Sider.style';

import { Breakpoints } from '../../assets/Variables.style';

const Sider = () => {
  const [width] = useWindowSize();
  const intl = useIntl();
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const siderStore = useSelector((state) => state.siderStore);

  const handleTogglerClick = () => {
    if (siderStore.isexpanded) dispatch({ type: 'SIDER_COLLAPSE' });
    else dispatch({ type: 'SIDER_EXPANDED' });
  };

  return (
    <>
      <Wrapper
        theme={theme.sider.wrapper}
        isexpanded={width > Breakpoints.lg ? siderStore.isexpanded : false}
      >
        <Content>
          <ContentInner>
            {width > Breakpoints.lg ? (
              <LogoBox theme={theme.sider.logobox}>
                <LogoHolder to='/'>
                  <Logo src={IMAGE_LOGO} alt={'Vinne'} />
                </LogoHolder>
              </LogoBox>
            ) : (
              ''
            )}
            {routes
              .filter(
                (route) =>
                  route.isMenu &&
                  (!route.isHiddenOnMobile ||
                    (route.isHiddenOnMobile && width > Breakpoints.lg))
              )
              .map((route, key) => (
                <Item
                  key={key}
                  to={route.path}
                  theme={theme.sider.item}
                  active={
                    history.location.pathname.startsWith(route.path)
                      ? String(true)
                      : undefined
                  }
                  title={intl.formatMessage({
                    id: `SIDER.${route.name}`,
                  })}
                  isexpanded={
                    width > Breakpoints.lg ? siderStore.isexpanded : false
                  }
                >
                  <ItemHolder>
                    <SVG
                      src={route.image}
                      alt={intl.formatMessage({
                        id: `SIDER.${route.name}`,
                      })}
                    />
                  </ItemHolder>
                  <ItemTitle
                    isexpanded={
                      width > Breakpoints.lg ? siderStore.isexpanded : false
                    }
                  >
                    {intl.formatMessage({
                      id: `SIDER.${route.name}`,
                    })}
                  </ItemTitle>
                </Item>
              ))}
            {width > Breakpoints.lg ? (
              <>
                <Grow />
                <Toggler
                  theme={theme.sider.toggler}
                  title={intl.formatMessage({ id: 'SIDER.TOGGLE_SIDEBAR' })}
                  onClick={() => {
                    handleTogglerClick();
                  }}
                >
                  <TogglerIcon
                    className='material-icons'
                    isToggle={siderStore.isexpanded ? true : undefined}
                  >
                    keyboard_arrow_right
                  </TogglerIcon>
                </Toggler>
              </>
            ) : (
              ''
            )}
          </ContentInner>
        </Content>
      </Wrapper>
    </>
  );
};

export default Sider;
